import { validateQueryParameters } from '@/helpers/verifyQueryParameters';
import { createAxiosInstance } from '@/plugins/axios.plugin';

export default class Notices {
  static SERVICE_NAME = 'notices';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  getNoticesList({ noticeId, courseId, isHighlight, search, perPage, page, order, sortBy }) {
    let orderBy = sortBy;

    if (order) {
      orderBy = orderBy + `:${order}`;
    }

    const query = validateQueryParameters({
      noticeId,
      isHighlight,
      perPage,
      search,
      page,
      orderBy
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/academic/courses/${courseId}/notices-board?${query}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  patchNoticeSequence({ courseId, noticeId, oldSequence, newSequence }) {
    return this.client.patch(`/academic/courses/${courseId}/notices-board/${noticeId}`, {
      oldSequence,
      newSequence
    })
      .then()
      .catch(error => Promise.reject(error.response.data.error));
  }

  createNotice({ courseId, payload }) {
    return this.client.post(`/academic/courses/${courseId}/notices-board`, _.omitBy(payload, _.isNil))
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  deleteNotice({ courseId, noticeId }) {
    return this.client.delete(`/academic/courses/${courseId}/notices-board/${noticeId}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  changeVisibility({ noticeId, payload }) {
    return this.client.patch(`/academic/notices-board/${noticeId}/change-visibility`, _.omitBy(payload, _.isNil))
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  editNotice({ courseId, noticeId, payload }) {
    return this.client.put(`/academic/courses/${courseId}/notices-board/${noticeId}`, _.omitBy(payload, _.isNil))
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  markAsReadNotice({ courseId, isHighlight, search, payload }) {
    const query = validateQueryParameters({
      isHighlight,
      search
    }, { skipNull: true, skipEmptyString: true });

    const endpoint = courseId ? `/academic/courses/${courseId}/notices-board/status?${query}` : '/academic/notices-board/status';

    if (!payload.startDate) {
      delete payload.startDate;
    }
    if (!payload.endDate) {
      delete payload.endDate;
    }

    return this.client.put(endpoint, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getGlobalNotices({ search,
    perPage,
    page,
    order,
    sortBy,
    academicMainId,
    noticeId,
    type,
    isReaded,
    startDate,
    endDate,
    isBlockingAccess,
    categoryIds,
    status,
    tags,
    startDatePublished,
    endDatePublished
  }) {
    let orderBy = sortBy;

    if (order) {
      orderBy = orderBy + `:${order}`;
    }

    const query = validateQueryParameters({
      perPage,
      search,
      page,
      orderBy,
      academicMainId,
      noticeId,
      type,
      isReaded,
      startDate,
      endDate,
      isBlockingAccess,
      categoryIds,
      status,
      tags,
      startDatePublished,
      endDatePublished
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/academic/notices-board?${query}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  createGlobalNotice({ payload }) {
    return this.client.post('/academic/notices-board', payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  editGlobalNotice({ noticeId, payload }) {
    return this.client.put(`/academic/notices-board/${noticeId}`, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  deleteGlobalNotice({ noticeId }) {
    return this.client.delete(`/academic/notices-board/${noticeId}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }
};
